<template>
  <div class="archives">
    <!-- 档案详情,医案详情，推荐结果 -->
    <!-- 地址栏有name为推荐结果页面,无name为档案详情页面 -->
    <!-- 第一个白框里的内容 -->
    <div class="outer-border margin-bottom-three">
      <el-row class="title-border-bottom" v-if="!$route.query.name">
        <div class="b-title fl">档案详情</div>
        <el-button type="warning" class="small-btn fr" v-if="!isYS" @click="
            fuZhen(
              form.da.medId,
              form.da.firstTime,
              form.da.otherNumbers[form.da.otherNumbers.length - 1].number
            )
          ">复诊</el-button>
        <span v-if="form.da.otherNumbers" class="fr">
          <!-- <span v-for="(itemB,indexB) in form.da.otherNumbers" :key="indexB">
                        <el-button
                            type="primary"
                            class="small-btn"
                            style="margin-right:10px"
                            v-if="form.da.unmber == itemB.number"
                            disabled
                        >{{toChinesNum(itemB.number)}}诊时</el-button>
                        <el-button
                            type="primary"
                            class="small-btn"
                            style="margin-right:10px"
                            v-else
                            @click="getDetailDangAn(itemB.id)"
                        >{{toChinesNum(itemB.number)}}诊时</el-button>
          </span>-->
          <el-select v-model="form.da.id" placeholder="请选择" @change="selectZhenShi" size="mini" class="small-select-mini">
            <el-option v-for="itemB in form.da.otherNumbers" :key="itemB.id" :label="toChinesNum(itemB.number) + '诊时'" :value="itemB.id"></el-option>
          </el-select>
        </span>
      </el-row>
      <el-row class="title-border-bottom" v-else>
        <div class="b-title fl">推荐结果</div>
        <el-button type="warning" class="small-btn fr" icon="el-icon-share" @click="shareF()">分享</el-button>
      </el-row>
      <el-col style="padding-right:20px">
        <share :config="config1" style="display:inline-block" v-if="isShare" class="fr"></share>
      </el-col>

      <div class="content-two">
        <el-form :model="form" status-icon ref="form" label-width="80px">
          <el-form-item label="基本信息:">
            <table class="table">
              <tr>
                <td class="table-title">姓名</td>
                <td>{{ form.da.name }}</td>
                <td class="table-title">性别</td>
                <td>{{ form.da.sex }}</td>
                <td class="table-title">年龄</td>
                <td>{{ form.da.age }}</td>
                <!--                <td class="table-title" v-if="form.da.sex == '女'">生育史</td>-->
                <!--                <td v-if="form.da.sex == '女'">-->
                <!--                  {{-->
                <!--                  form.ya.childbearingHistory-->
                <!--                  ? form.ya.childbearingHistory-->
                <!--                  : ""-->
                <!--                  }}-->
                <!--                </td>-->
                <!--                <td v-if="form.da.sex == '女'" class="table-title red-long-btn">孕妇</td>-->
                <!--                <td v-if="form.da.sex == '女'" class="red-color-font">{{ isYF(form.ya.isPregnant) }}</td>-->
              </tr>
              <!--              <tr>-->
              <!--                <td class="table-title">个人史</td>-->
              <!--                <td colspan="4" v-if="form.da.sex == '女'">{{ ges(form.ya.personageHistorys) }}</td>-->
              <!--                <td colspan="2" v-else>{{ ges(form.ya.personageHistorys) }}</td>-->

              <!--                <td class="table-title">既往史</td>-->
              <!--                <td-->
              <!--                  colspan="4"-->
              <!--                  v-if="form.da.sex == '女'"-->
              <!--                >{{ jwyws(form.ya.previousHistorys, "previousHistory") }}</td>-->
              <!--                <td colspan="2" v-else>{{ jwyws(form.ya.previousHistorys, "previousHistory") }}</td>-->
              <!--              </tr>-->
              <tr>
                <!--                <td class="table-title">家族史</td>-->
                <!--                <td colspan="4" v-if="form.da.sex == '女'">{{ jzs(form.ya.familyHistory) }}</td>-->
                <!--                <td colspan="2" v-else>{{ jzs(form.ya.familyHistory) }}</td>-->

                <td class="table-title">药物过敏史</td>
                <td colspan="10" v-if="form.da.sex == '女'">{{ jwyws(form.ya.medicineIrritabilityHistory, "medicine") }}</td>
                <td colspan="10" v-else>{{ jwyws(form.ya.medicineIrritabilityHistory, "medicine") }}</td>
              </tr>
            </table>
          </el-form-item>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <el-form-item label="初诊时间:">
                <el-date-picker disabled size="small" v-model="form.da.firstTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="初诊时间" style="width:auto"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="诊时:">
                <el-input size="small" v-model="form.da.unmber1" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="本诊时间:">
                <el-date-picker disabled size="small" v-model="form.da.visitTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="本诊时间" style="width:auto"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">

          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主要病症:">
                {{form.da.disease}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【古方名称】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.gfName }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【古方追溯】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.source }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【编码章节】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.section }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【古籍原文】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro" v-html="form.da.originalText"></el-col>
          </el-row>
          <!--          <el-row>-->
          <!--            <el-col :span="24" class="medinum-kuokao">【古方年代】</el-col>-->
          <!--          </el-row>-->
          <!--          <el-row>-->
          <!--            <el-col :span="24" class="intro">{{ form.da.years }}</el-col>-->
          <!--          </el-row>-->
          <!--          <el-row>-->
          <!--            <el-col :span="24" class="medinum-kuokao">【作&nbsp;&nbsp;&nbsp;&nbsp;者】</el-col>-->
          <!--          </el-row>-->
          <!--          <el-row>-->
          <!--            <el-col :span="24" class="intro"> {{ form.da.author }}</el-col>-->
          <!--          </el-row>-->

          <el-row v-if="wuxing.length > 0">
            <el-col>
              <el-form-item :span="24" label="诊断分析:"></el-form-item>
              <p class="remarks">系统在中医古籍知识为基础上，结合您选择的症状，推理出可能的病机。</p>
              <div class="wuxi">
                <div class="wuxing" v-for="item in wuxing" :key="item.id">
                  <div class="wuxing_name" :span="6">{{item.attribute}}</div>
                  <div class="wuxing_num" :span="18">{{item.types}}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 古代方剂 -->
          <el-row v-if="gdfj.length > 0">
            <el-col :span="24">
              <el-form-item class="margin-left-zero">
                <table class="table">
                  <tr>
                    <td :rowspan="Math.ceil(gdfj.length / 2) + 2" class="table-a">古代方剂</td>
                    <td colspan="6">{{ form.da.gfName }}</td>
                  </tr>
                  <tr>
                    <td>中草药名称</td>
                    <td>剂量</td>
                    <td>制法</td>
                    <td v-if="gdfj.length - 1">中草药名称</td>
                    <td v-if="gdfj.length - 1">剂量</td>
                    <td v-if="gdfj.length - 1">制法</td>
                  </tr>
                  <tr v-for="(itemG, indexG) in gdfj" :key="itemG.id" v-show="indexG % 2 == 0">
                    <td>
                      <span :class="[itemG.approvalStatus == '1' ? 'soan' : '']" @click="drugClick(itemG)">{{ gdfj[indexG].medicineName }}</span>
                      <img :src="require('@/assets/list/jin.png')" alt class="vertical-middle" v-if="gdfj[indexG].anMedicineType == '0'" />
                      <img :src="require('@/assets/list/fan.png')" alt class="vertical-middle" v-if="gdfj[indexG].xfxwMedicineType == '1'" />
                      <img :src="require('@/assets/list/wei2.png')" alt class="vertical-middle" v-if="gdfj[indexG].xfxwMedicineType == '2'" />
                    </td>
                    <td>{{ gdfj[indexG].dosage }}{{ gdfj[indexG].unit }}</td>
                    <td style="width: 20%">{{gdfj[indexG].zyzf}}</td>
                    <td v-if="indexG < gdfj.length - 1">
                      <span :class="[gdfj[indexG + 1].approvalStatus == '1' ? 'soan' : '']" @click="drugClicks(gdfj[indexG + 1])">{{ gdfj[indexG + 1].medicineName }}</span>
                      <img :src="require('@/assets/list/jin.png')" alt class="vertical-middle" v-if="gdfj[indexG + 1].anMedicineType == '0'" />
                      <img :src="require('@/assets/list/fan.png')" alt class="vertical-middle" v-if="gdfj[indexG + 1].xfxwMedicineType == '1'" />
                      <img :src="require('@/assets/list/wei2.png')" alt class="vertical-middle" v-if="gdfj[indexG + 1].xfxwMedicineType == '2'" />
                    </td>
                    <td v-if="indexG < gdfj.length - 1">{{ gdfj[indexG + 1].dosage }}{{ gdfj[indexG + 1].unit }}</td>
                    <td style="width: 20%" v-if="indexG < gdfj.length - 1">{{gdfj[indexG + 1].zyzf}}</td>

                    <!-- <td v-if="indexG < gdfj.length - 2">
                      {{ gdfj[indexG + 2].medicineName }}
                      <img
                        :src="require('@/assets/list/jin.png')"
                        alt
                        class="vertical-middle"
                        v-if="gdfj[indexG + 2].anMedicineType == '0'"
                      />
                      <img
                        :src="require('@/assets/list/fan.png')"
                        alt
                        class="vertical-middle"
                        v-if="gdfj[indexG + 2].xfxwMedicineType == '1'"
                      />
                      <img
                        :src="require('@/assets/list/wei2.png')"
                        alt
                        class="vertical-middle"
                        v-if="gdfj[indexG + 2].xfxwMedicineType == '2'"
                      />
                    </td>
                    <td
                      v-if="indexG < gdfj.length - 2"
                    >{{ gdfj[indexG + 2].dosage }}{{ gdfj[indexG + 2].unit }}</td> -->
                  </tr>
                </table>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 当代方剂 -->
          <el-row v-if="ddfj.length > 0">
            <el-col :span="24">
              <el-form-item class="margin-left-zero">
                <table class="table">
                  <tr>
                    <td :rowspan="Math.ceil(ddfj.length / 2) + 2" class="table-a">当代方剂</td>
                    <td colspan="6">
                      <span style="margin-left:14%">{{ form.da.gfName }}</span>
                      <span class="fr">
                        <el-button type="primary" class="btn-medium" style="margin-left:10px" @click="onChangeEvaluate" v-if="!evaluateInfo.id">评价</el-button>
                        <el-button type="warning" class="btn-medium" style="background-color: #f64420;" v-if="ddfj.length > 0 && !isYS" @click="addCar(form.da.cfId, 1,0)">估药</el-button>
                        <el-button type="warning" class="btn-medium" v-if="userInfo.userType==2" @click="editFangJi()">修改方剂</el-button>
                        <el-button type="warning" class="btn-medium" v-if="userInfo.userType==1" @click="addCar(form.da.cfId, 1,2)">咨询</el-button>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>中草药名称</td>
                    <td>剂量</td>
                    <td>制法</td>
                    <td v-if="ddfj.length - 1">中草药名称</td>
                    <td v-if="ddfj.length - 1">剂量</td>
                    <td v-if="ddfj.length - 1">制法</td>
                  </tr>
                  <tr v-for="(itemD, indexD) in ddfj" :key="indexD.id" v-show="indexD % 2 == 0">
                    <td>
                      <span :class="[ddfj[indexD].approvalStatus == '1' ? 'soan' : '']" @click="drugClick(ddfj[indexD])">{{ ddfj[indexD].medicineName }}</span>
                      <img :src="require('@/assets/list/ti.png')" alt class="vertical-middle" v-if="ddfj[indexD].rpMedicineType == '0'" />
                      <img :src="require('@/assets/list/fan.png')" alt class="vertical-middle" v-if="ddfj[indexD].xfxwMedicineType == '1'" />
                      <img :src="require('@/assets/list/wei2.png')" alt class="vertical-middle" v-if="ddfj[indexD].xfxwMedicineType == '2'" />
                    </td>
                    <td>{{ ddfj[indexD].dosage }}{{ ddfj[indexD].unit }}</td>
                    <td style="width: 20%">{{ ddfj[indexD].zyzf }}</td>

                    <td v-if="indexD < ddfj.length - 1">
                      <span :class="[ddfj[indexD + 1].approvalStatus == '1' ? 'soan' : '']" @click="drugClick(ddfj[indexD + 1])">{{ ddfj[indexD + 1].medicineName }}</span>
                      <img :src="require('@/assets/list/ti.png')" alt class="vertical-middle" v-if="ddfj[indexD + 1].rpMedicineType == '0'" />
                      <img :src="require('@/assets/list/fan.png')" alt class="vertical-middle" v-if="ddfj[indexD + 1].xfxwMedicineType == '1'" />
                      <img :src="require('@/assets/list/wei2.png')" alt class="vertical-middle" v-if="ddfj[indexD + 1].xfxwMedicineType == '2'" />
                    </td>
                    <td v-if="indexD < ddfj.length - 1">
                      {{ ddfj[indexD + 1].dosage }}{{ ddfj[indexD + 1].unit }}
                    </td>
                    <td style="width: 20%" v-if="indexD < ddfj.length - 1">
                      
                      {{ddfj[indexD + 1].zyzf}}
                    </td>
                 
                  </tr>
                </table>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 医师修正方剂 -->
          <el-row v-if="ysxzfj.length > 0">
            <el-col :span="24">
              <el-form-item class="margin-left-zero">
                <table class="table">
                  <tr>
                    <td :rowspan="Math.ceil(ysxzfj.length / 2) + 2" class="table-a">修正方剂</td>
                    <td colspan="6">
                      <span style="margin-left:14%">
                        {{ form.da.gfName }} +
                        <span v-if="form.da.physician">{{ form.da.physician.name }} +</span>
                        {{ getTime(ysxzfj[0].createDate) }}
                      </span>
                      <span class="fr">
                        <!-- <el-button
                          type="primary"
                          class="btn-medium"
                          style="margin-left:10px"
                          @click="onChangeEvaluate"
                          v-if="!evaluateInfo.id"
                        >评价</el-button> -->
                        <el-button type="warning" class="btn-medium" v-if="ysxzfj.length > 0 && !isYS" style="margin-left:10px;background-color: #f64420;" @click="addCar(form.da.cfId, 2,0)">估药</el-button>
                        <el-button type="warning" class="btn-medium" @click="editFangJi()" v-if="ysxzfj.length > 0">修改方剂</el-button>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>中草药名称</td>
                    <td>剂量</td>
                    <td>制法</td>
                    <td v-if="ysxzfj.length - 1">中草药名称</td>
                    <td v-if="ysxzfj.length - 1">剂量</td>
                    <td v-if="ysxzfj.length - 1">制法</td>
                  </tr>
                  <tr v-for="(itemY, indexY) in ysxzfj" :key="indexY.id" v-show="indexY % 2 == 0">
                    <td>{{ ysxzfj[indexY].medicineName }}</td>
                    <td>{{ ysxzfj[indexY].dosage }}{{ ysxzfj[indexY].unit }}</td>
                    <td style="width: 20%">{{ysxzfj[indexY].method}}</td>

                    <td v-if="indexY < ysxzfj.length - 1">{{ ysxzfj[indexY + 1].medicineName }}</td>
                    <td v-if="indexY < ysxzfj.length - 1">
                      {{ ysxzfj[indexY + 1].dosage}}{{ ysxzfj[indexY + 1].unit }}
                    </td>
                    <td style="width: 20%" v-if="indexY < ysxzfj.length - 1">{{ysxzfj[indexY+1].method}}</td>
                    <!-- <td v-if="indexY < ysxzfj.length - 2">{{ ysxzfj[indexY + 2].medicineName }}</td>
                    <td v-if="indexY < ysxzfj.length - 2">
                      {{ ysxzfj[indexY + 2].dosage
                      }}{{ ysxzfj[indexY + 2].unit }}
                    </td> -->
                  </tr>
                </table>
              </el-form-item>
            </el-col>
          </el-row>
          <p class="test" v-if="jinyao">
            <!-- <p class="test"> -->
            <span>禁</span>：禁止使用药物。
          </p>
          <p class="test1" v-if="jinyao">
            <!-- <p class="test1" > -->
            <span>替</span>：国家法律规定古方中的中药已禁用，根据中医知识替换成为此药，替换的药物与原药物的功效基本相同。
          </p>
          <p class="test2" v-if="fanyao">
            <!-- <p class="test2" > -->
            <span>反</span>：指配伍禁忌，指某些中药合用会产生或增强剧烈的毒副作用或降低、破坏药效，因而应该避免配合应用。
          </p>
          <p class="test3" v-if="weiyao">
            <!-- <p class="test3" > -->
            <span>畏</span>：同反药配伍禁忌，指不要让有些药物合用，合用后的后果会产生各种副作用。
          </p>

          <p class="smallRedSize" v-if="form.da.sex == '女' && !isYS">如您是孕妇或您一年内有备孕意向，请线下就医购药！</p>
          <el-row>
            <el-col :span="24">
              <el-form-item class="margin-left-zero border-ten"></el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="medinum-kuokao">【功效主治】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.zhuzhi }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【处方制法】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.method }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【古代煎服法】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.yf }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【现代煎服法】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.mdm }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="medinum-kuokao">【注意事项】</el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="intro">{{ form.da.attention }}</el-col>
          </el-row>
          <!--          <el-row>-->
          <!--            <el-col :span="24" class="medinum-kuokao">【临床应用】</el-col>-->
          <!--          </el-row>-->
          <!--          <el-row>-->
          <!--            <el-col :span="24" class="intro">-->
          <!--              {{-->
          <!--              form.da.clinicApplication-->
          <!--              }}-->
          <!--            </el-col>-->
          <!--          </el-row>-->

        </el-form>
      </div>
    </div>
    <div class="evaluate-table-box" v-if="evaluateFromVisible && !evaluateInfo.id" id="evaluateDom" ref="evaluateDom">
      <table class="table">
        <tr>
          <td>疗效评价</td>
          <td>
            <el-radio-group v-model="levelValue">
              <el-radio :label="level.value" :key="level.value" v-for="level in levelList">{{ level.lableTwo }}</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <el-input v-model="evaluateText" type="textarea" placeholder="评价内容..." class="my-desc" :autosize="{ minRows: 4, maxRows: 8 }" maxlength="500" show-word-limit></el-input>
            <el-button type="primary" class="small-btn fr sure" @click="saveEvaluate">发布</el-button>
          </td>
        </tr>
      </table>
    </div>

    <div class="evaluate-msg-box" v-if="evaluateInfo.id">
      <div class="evaluate-msg">
        <div class="head">
          <div class="user-info">
            <img :src="$store.state.imgUrl+evaluateInfo.headImg" />
            <div>
              我的
              <span>评价</span>
            </div>
          </div>
          <div class="level">
            疗效评价 :
            <span>{{ levelText }}</span>
          </div>
        </div>

        <div class="evaluate-msg-text">{{ evaluateInfo.content }}</div>
      </div>
    </div>
    <!-- ===========================================临时添加 可删除================================================== -->
    <!-- <el-table :data="tableData" border :header-cell-style="{background:'#fffaf6',color:'#606266'}">
      <el-table-column prop="mc" label="中草药名称" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="xw" label="性味归经" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="gn" label="功能主治" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="yf" label="用量用法" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="zy" label="注意事项" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pz" label="炮制" align="center" show-overflow-tooltip>
      </el-table-column>
    </el-table> -->

    <!-- ===================================临时添加 可删除========================================================== -->

    <!-- 第二个白框里的内容 -->
    <!-- v-if="form.da.physician" -->
    <!-- 20210706-->
    <!-- <div class="second-table">
      <table class="table set-height-thirty-six goutongTable">
        <tr>
          <td>医师姓名</td>
          <td class="grey-word">{{ form.da.physician ? form.da.physician.name : "" }}</td>
          <td>所属医院</td>
          <td class="grey-word">{{ form.da.physician ? form.da.physician.hospital : "" }}</td>
          <td v-if="form.da.physicianCommunicationList">初次沟通时间</td>
          <td class="grey-word" v-if="form.da.physicianCommunicationList">
            <span>
              {{
              form.da.physicianCommunicationList.length > 0
              ? getTime(
              form.da.physicianCommunicationList[
              form.da.physicianCommunicationList.length - 1
              ].createDate
              )
              : ""
              }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <el-input
              type="textarea"
              v-model="content"
              placeholder="我的描述..."
              class="my-desc"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="500"
              show-word-limit
            ></el-input>
            <el-button type="primary" class="small-btn fr sure" @click="askYiShi()">确定</el-button>
          </td>
        </tr>
      </table>
    </div> -->
    <!-- :class="noDisplay?'display-none':''" -->
    <!-- <el-row class="text-center margin10" v-if="!isYS">
      <el-col :span="24">
        <el-button type="primary" class="small-btn" @click="consultation()">咨询医师</el-button>
      </el-col>
    </el-row> -->

    <!-- 第三个白文本框的内容 -->
    <div class="outer-border three-white" v-if="jzjl.length > 0">
      <div v-for="itemJ in jzjl" :key="itemJ.id">
        <el-row class="common-row">
          <!-- 是医师：{{isYS}}
          登陆人id和replyPeopleId是否相等{{userInfo.id == itemJ.replyPeopleId}}-->
          <el-col :span="2">
            <img :src="$store.state.imgUrl+itemJ.replyPeopleHeadImg" alt class="head-img" />
          </el-col>
          <el-col :span="18" class="common-list">
            <span class="my">{{ itemJ.replyPeople }}</span>
            <span v-if="isYS">
              <span v-if="userInfo.id === itemJ.replyPeopleId">
                <span class="desc-words">:回复</span>
              </span>
              <span v-else>
                <span class="desc-words">:描述</span>
              </span>
            </span>
            <span v-else>
              <span v-if="userInfo.id === itemJ.replyPeopleId">
                <span class="desc-words">:描述</span>
              </span>
              <span v-else>
                <span class="desc-words">:回复</span>
              </span>
            </span>

            <div style="margin-top:12px">{{ itemJ.content }}</div>
          </el-col>
          <el-col :span="4">
            <span class="date-time fr">{{ getTime(itemJ.createDate) }}</span>
          </el-col>
        </el-row>
      </div>
      <!-- <el-row>
                <el-col :span="24" class="more">
                    <el-button class>加载更多</el-button>
                </el-col>
      </el-row>-->
    </div>
    <el-row class="center-more">
      <el-col :span="24">
        <div class="view-more" @click="moreDate()" v-if="alljzjl.length > 4 && show">查看更多</div>
      </el-col>
    </el-row>
    <!-- 医师修正方剂弹框 -->
    <el-dialog :title="form.da.gfName" :visible.sync="dialogTableVisible" :show-close="false" :close-on-click-modal="false">
      <div class="margin-left-zero margin20" v-if="ysxzfj.length > 0">
        <table class="table">
          <tr>
            <!-- 当代方剂-->
            <td>草药名称</td>
            <td style="width: 29%">剂量</td>
            <td>单位</td>
            <td>制法</td>
          </tr>
          <tr v-for="(itemYX, indexYX) in xgysxzfj" :key="itemYX.id">
            <td>
              <el-select v-model="itemYX.medicineName" remote :remote-method="remoteMethod" @change='handleChange' class="set-small-width" filterable placeholder="请输入草药名称"
                no-data-text='该药品不存在，请输入其他药品查询' clearable>
                <el-option v-for="(item,index) in medicinelist" :key="index" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-autocomplete
                class="set-small-width"
                v-model="itemYX.medicineName"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect(itemYX)"
                placeholder="请输入草药名称"
              ></el-autocomplete> -->
            </td>
            <td>
              <el-input v-model="itemYX.dosage" onkeyup="value=value.replace(/[^\d^\.]+/g,'')" placeholder="请输入剂量，格式为数字"></el-input>
            </td>
            <td>
              <el-select v-model="itemYX.unit" class="set-small-width">
                <el-option v-for="(item,index) in unitMeasure" :key="index" :label="item.lableTwo" :value="item.lableTwo"></el-option>
              </el-select>
            </td>
            <td>
              <el-input v-model="itemYX.method" class="set-small-width leftSty" autosize type="textarea" placeholder="请输入制法"></el-input>
            </td>
            <td>
              <img :src="require('@/assets/img/reduce.png')" alt class="vertical-middle" @click="reduceRow(indexYX)" />
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <img :src="require('@/assets/img/addRed.png')" alt class="vertical-middle" @click="addRow()" />
            </td>
          </tr>
        </table>
      </div>
      <div class="margin-left-zero margin20" v-else>
        <table class="table">
          <tr>
            <!-- 修改方剂 -->
            <td>草药名称</td>
            <td style="width: 29%">剂量</td>
            <td>单位</td>
            <td>制法</td>
          </tr>
          <tr v-for="(itemDX, indexDX) in xgysxzfj" :key="itemDX.id">
            <td>
              <el-select v-model="itemDX.medicineName" remote :remote-method="remoteMethod" @change='handleChange' class="set-small-width" filterable placeholder="请输入草药名称"
                no-data-text='该药品不存在，请输入其他药品查询' clearable>
                <el-option v-for="(item,index) in medicinelist" :key="index" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-autocomplete
                ref="autocomplete"
                class="set-small-width"
                v-model="itemDX.medicineName"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect(itemDX)"
                placeholder="请输入草药名称"
              ></el-autocomplete> -->
            </td>
            <td>
              <el-input v-model="itemDX.dosage" onkeyup="value=value.replace(/[^\d^\.]+/g,'')" class="set-small-width leftSty" :controls="false" placeholder="请输入剂量，格式为数字"></el-input>
            </td>
            <td>
              <el-select v-model="itemDX.unit" class="set-small-width">
                <el-option v-for="(item,index) in unitMeasure" :key="index" :label="item.lableTwo" :value="item.lableTwo"></el-option>
              </el-select>
            </td>
            <td>
              <el-input v-model="itemDX.method" autosize class="set-small-width leftSty" type="textarea" placeholder="请输入制法"></el-input>
            </td>
            <td>
              <img :src="require('@/assets/img/reduce.png')" alt class="vertical-middle" @click="reduceRow(indexDX)" />
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <img :src="require('@/assets/img/addRed.png')" alt class="vertical-middle" @click="addRow()" />
            </td>
          </tr>
        </table>
      </div>
      <el-row class="text-center">
        <el-col :span="24">
          <el-button type="danger" @click="submitEdit()">确定</el-button>
          <el-button type="info" @click="cancle()">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog title="权限访问" :visible.sync="dialogTableVisibleQX" :close-on-click-modal="false" class="dialogQX" center :show-close="false">
      <p class="contentQX text-center">
        是否向
        <span class="orangeQX">{{ form.da.name }}</span>
        申请查看{{ form.da.disease }}的其他诊时权限
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="submitQX()" class="smallBtn red">确定</el-button>
        <el-button type="primary" @click="cancleQX()" class="smallBtn blue">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "archives",
  components: {},
  data () {
    return {
      tableData: [
        {
          mc: '一枝黄花',
          xw: '辛、苦，凉。归肺、肝经',
          gn: '清热解毒，疏散风热。用于喉痹',
          yf: '9～15g',
          zy: '药物过敏史',
          pz: '除去杂质，喷淋清水'
        },
        {
          mc: '麝香',
          xw: '辛，温。归心、脾经',
          gn: '开窍醒神，活血通经，消肿止痛',
          yf: '0.03～0.1g',
          zy: '取毛壳麝香',
          pz: '密闭，置阴凉干燥处'
        },
        {
          mc: '人工牛黄',
          xw: '甘，凉。归心、肝经',
          gn: '清热解毒，化痰定惊。用于痰热谵狂',
          yf: '1～3g',
          zy: '不宜与郁金同用',
          pz: '除去杂质，筛去灰屑。用时捣碎'
        },
        {
          mc: '人参',
          xw: '甘、微苦，微温。归脾、肺、心、肾经',
          gn: '大补元气，复脉固脱，补脾益肺',
          yf: '3～9g',
          zy: '不宜与藜芦、五灵脂同用',
          pz: '置阴凉干燥处，密闭保存，防蛀。'
        },
        {
          mc: '人参叶',
          xw: '苦、甘，寒。归肺、胃经',
          gn: '补气，益肺，祛暑，生津。',
          yf: '0.03～0.7g',
          zy: '不宜与藜芦、五灵脂同用',
          pz: '置阴凉干燥处，防潮'
        },
        {
          mc: '八角茴香',
          xw: '辛，温。归肝、肾、脾、胃经',
          gn: '温阳散寒，理气止痛。',
          yf: '3～6g',
          zy: '不宜与藜芦、五灵脂同用。',
          pz: '置阴凉干燥处，防潮'
        },
      ],
      // noDisplay: false, //咨询医师是否显示
      form: {
        ya: {}, // 医案详情
        da: {} //档案详情
      },
      wuxing: [], // 五行诊断
      gdfj: [], //古代方剂
      ddfj: [], //当代方剂
      maxDoseList: [], //购药暂存当代方剂最大剂量判断
      ysxzfj: [], //医师修正方剂
      xgysxzfj: [], //修改医师修正方剂
      jzjl: [], //显示最新的就诊记录
      oddjzjl: [], //之前的就诊记录
      alljzjl: [], //全部就诊记录
      content: "", //咨询医师内容
      dialogTableVisible: false, //修改方剂弹框
      medicinelist: [], // 药名称
      medicinelist_all: [], // 草药集合
      rangeNumber: 10, // 下拉框展示默认10条
      dialogTableVisibleQX: false, //权限访问弹框
      isYS: false,
      zhenshiId: "",
      show: false, //查看更多是否显示
      jinyao: false,
      fanyao: false,
      weiyao: false,
      evaluateFromVisible: false, // 评价输入框,
      levelList: [],
      levelValue: "", //评价等级
      evaluateText: "", //评价框绑定
      evaluateInfo: {}, // 评价详情
      levelText: "", //评价文字展示
      restaurants: [],
      unitMeasure: []
    };
  },
  methods: {
    moreDate () {
      this.jzjl = this.jzjl.concat(this.oddjzjl);
      this.show = false;
    },
    selectZhenShi (val) {
      this.getDetailDangAn(val);
    },
    cancleQX () {
      let that = this;
      that.dialogTableVisibleQX = false;
      that.form.da.id = that.zhenshiId;
    },
    async unitMeasu () {
      let url = "/sysDict/findByType";
      let params = {
        type: "cdoseunit"
      }
      this.$http.post(url, params).then(res => {
        this.unitMeasure = res.data.data
      })
    },
    //获取档案详情
    async getDetailDangAn (id) {
      let that = this;
      let params = {
        id: id,
        loginIdentity: JSON.parse(sessionStorage.getItem("YS")),
        gfId: that.$route.query.gfId
      };
      let url = "medicalCasesPc/geArchivesById";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.form.da = res.data;
            // console.log('that.form.da', that.form.da);
            // console.log(that.form.da.method);
            that.zhenshiId = res.data.id;
            //诊断分析
            if (that.form.da.archivesDiagnoanaly) {
              that.wuxing = that.form.da.archivesDiagnoanaly;
            }
            if (that.form.da.unmber) {
              that.form.da.unmber1 =
                that.toChinesNum(that.form.da.unmber) + "诊时";
            }
            // 古代方剂
            if (that.form.da.ancientPrescriptionSlaves) {
              that.gdfj = that.form.da.ancientPrescriptionSlaves;
              for (let index = 0; index < that.gdfj.length; index++) {
                if (that.gdfj[index].anMedicineType == 0) {
                  that.jinyao = true;
                }
                if (that.gdfj[index].xfxwMedicineType == 1) {
                  that.fanyao = true;
                } else if (that.gdfj[index].xfxwMedicineType == 2) {
                  that.weiyao = true;
                }
              }
              let ancientPrescriptionCy =that.form.da.ancientPrescriptionCy ? that.form.da.ancientPrescriptionCy : [];
                if (ancientPrescriptionCy.length) {
                  ancientPrescriptionCy.forEach(item => {
                    item.medicineName = item.ypName;
                  });
                  that.gdfj = that.gdfj.concat(
                    ancientPrescriptionCy);
                }
            }
            //当代方剂
            if (that.form.da.prescriptionSlaves) {
              that.ddfj = that.form.da.prescriptionSlaves;
              let ancientPrescriptionCy = that.form.da.ancientPrescriptionCy ? that.form.da.ancientPrescriptionCy : [];
                if (ancientPrescriptionCy.length) {
                  ancientPrescriptionCy.forEach(item => {
                    item.medicineName = item.ypName;
                    item.method = item.zyzf;
                    item.medicine = item.bizId;
                  });
                  that.ddfj = that.ddfj.concat(
                    ancientPrescriptionCy);
                }
            }
            //当代方剂maxDoseList提交判断
            // if (that.form.da.maxDoseList) {
            that.maxDoseList = that.form.da.maxDoseList;
            // }
            //医师修正方剂
            if (that.form.da.physicianChangePrescriptionList) {
              that.ysxzfj = that.form.da.physicianChangePrescriptionList;
            }
            //就诊记录
            if (that.form.da.physicianCommunicationList) {
              that.alljzjl = that.form.da.physicianCommunicationList;
              if (that.alljzjl.length > 4) {
                that.show = true;
                that.jzjl = [];
                that.oddjzjl = [];
                for (let i = 0; i < that.alljzjl.length; i++) {
                  if (i < 4) {
                    that.jzjl.push(that.alljzjl[i]);
                  } else {
                    that.oddjzjl.push(that.alljzjl[i]);
                  }
                }
              } else {
                that.jzjl = that.alljzjl;
              }
            }
            //评价信息
            that.evaluateInfo = res.data.evaluate || {};

            if (that.evaluateInfo.id) {
              that.evaluateInfo.headImg = res.data.headImg;
              that.$nextTick(() => {
                that.levelText = that.levelList.find(
                  ele => ele.value == that.evaluateInfo.evaluateGrade
                ).lableTwo;
              });

              // console.log(that.evaluateInfo);
            }
          } else if (res.code == 20001) {
            that.dialogTableVisibleQX = true;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //获取医案详情
    async getDetailYiAn (id) {
      let that = this;
      let params = {
        id: id
      };
      let url = "medicalCasesPc/getYaById";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.form.ya = res.data;
            if (that.form.ya.childbearingHistory) {
              if (that.form.ya.childbearingHistory == "5") {
                that.form.ya.childbearingHistory = "多个";
              }
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //咨询医师
    consultation () {
      this.$router.push({
        path: "/doctorList",
        query: {
          id: this.$route.query.id,
          medId: this.$route.query.medId
        }
      });
    },
    //获取医师信息
    async getYiShi (id) {
      let that = this;
      let params = {
        userId: id
      };
      let url = "physician/getPhysician";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.form.da.physician = {};
            for (let i = 0; i < that.form.da.physician.length; i++) {
              that.form.da.physician[i] = "";
            }
            that.form.da.physician.name = res.data.realName;
            that.form.da.physician.hospital = res.data.hospital;
            that.form.da.physicianCommunicationList = [];
            that.form.da.physicianCommunicationList.push({
              createDate: new Date()
            });
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //咨询医师确定按钮
    askYiShi () {
      let that = this;
      let ysid = "";
      if (that.$route.query.ysId) {
        ysid = that.$route.query.ysId;
      } else {
        if (JSON.parse(sessionStorage.getItem("YS"))) {
          // 医师，取档案id
          ysid = that.form.ya.userId;
        } else {
          //普通用户
          ysid = that.form.da.physician ? that.form.da.physician.id : "";
        }
      }
      if (!ysid) {
        that.$message({
          type: "warning",
          message: "请您先去选择一个医师进行咨询"
        });
        return false;
      }
      if (!that.content) {
        that.$message({
          type: "error",
          message: "请您输入内容"
        });
        return false;
      }

      let params = {
        physicianDiagnoseId:
          that.form.da.physicianCommunicationList[0].physicianDiagnoseId,
        replyPeople: that.userInfo.id,
        lookPeople: ysid,
        // archivesId: that.$route.query.id,
        archivesId: that.id, //从患者消息来路由中无id，存在了localstorage中
        content: that.content,
        ys: JSON.parse(sessionStorage.getItem("YS"))
      };
      let url = "physician/physicianConsult";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            // that.noDisplay = true;
            that.content = "";
            that.getDetailDangAn(that.id);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //修改方剂弹框，
    //有医师修正方剂显示医师修正方剂
    //没有医师修正方剂显示当代方剂
    editFangJi () {
      let that = this;
      that.alldrug()
      that.dialogTableVisible = true;
      // this.timeout = setTimeout(() => {
      //   that.getMedicine();
      // }, 5000);
      // clearTimeout(this.timeout);
      // setTimeout(that.getMedicine(), 5000);
      // that.getMedicine();
      if (that.ysxzfj.length > 0) {
        that.xgysxzfj = JSON.parse(JSON.stringify(that.ysxzfj));
      } else {
        that.xgysxzfj = JSON.parse(JSON.stringify(that.ddfj));
       
      }
    },
    // 远程搜索
    remoteMethod (query) {
      if (query !== '') {
        setTimeout(() => {
          this.medicinelist = this.medicinelist_all.filter(item => {
            return item.value.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.medicinelist = this.medicinelist_all.slice(0, this.rangeNumber);
      }
    },
    // 下拉框获取lable值
    handleChange (id) {
      let val = this.medicinelist.find((item) => {
        return item.id === id
      })
      this.xgysxzfj.map(items => {
        if (items.medicineName === id) {
          items.medicineName = val.value
          items.medicine = val.id
        }
      })
    },
    //确定修改方剂
    submitEdit () {
      let that = this;
      let flag = true;
      for (let i = 0; i < that.xgysxzfj.length; i++) {
        if (that.xgysxzfj[i].medicine == "") {
          flag = false;
          break;
        }
        if (that.xgysxzfj[i].dosage == "") {
          flag = false;
          break;
        }
        if (that.xgysxzfj[i].dosage != "") {
          // if (!that.numPanDuan(that.xgysxzfj[i].dosage)) {
          //   flag = false;
          // }
        }
        if (that.xgysxzfj[i].unit == "") {
          flag = false;
          break;
        }
      }
      if (flag == false) {
        that.$message.error("请将草药信息填写完整,且剂量必须为数字！");
        return false;
      }
      let params = {
        gfId:that.$route.query.gfId,
        archivesId: that.$route.query.id,
        physicianChangePrescriptions: that.xgysxzfj
      };
      let url = "physician/physicianChangePrescription";
      // console.log(params)
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.dialogTableVisible = false;
            that.getDetailDangAn(that.$route.query.id);
            // location.reload();
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //取消修改方剂
    cancle () {
      let that = this;
      that.dialogTableVisible = false;
    },
    // 添加一行
    addRow () {
      let that = this;
      that.xgysxzfj.push({
        medicine: "",
        dosage: "",
        unit: ""
      });
    },
    //减少一行
    reduceRow (index) {
      return this.$confirm('确定删除选中的数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let that = this;
        that.xgysxzfj.splice(index, 1);
      });
    },
    //得到所有的中草药
    alldrug () {
      let that = this;
      let url = "physician/listAllZY";
      let params = {
        atName: ''
      };
      that.$http.post(url, params).then(res => {
        res = res.data;
        if (res.code == 200) {
          let liatArr = res.data
          that.medicinelist_all = res.data
          that.medicinelist = liatArr.slice(0, this.rangeNumber)
        }
      })
    },
    // 搜索数据

    querySearchAsync (queryString, callback) {
      let that = this;
      let url = "physician/listAllZY";
      let params = {
        atName: queryString
      };
      that.$http.post(url, params).then(res => {
        res = res.data;
        if (res.data.length === 0) {
        }
        if (res.code == 200) {
          that.medicinelist = res.data;
          for (let i of res.data) {
            if (i.value === queryString) {
              callback(new Error('该药品不存在，请	输入其他药品查询'))
            }
          }
          callback(that.medicinelist);
        } else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelect (item) {
      let that = this;
      for (let index = 0; index < that.medicinelist.length; index++) {
        if (item.medicineName == that.medicinelist[index].value)
          item.medicine = that.medicinelist[index].id;
      }
    },
    //向用户申请其他诊时权限
    submitQX () {
      let that = this;
      let params = {
        id: that.jzjl[0].physicianDiagnoseId
      };
      let url = "physician/physicianWantLook";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.dialogTableVisibleQX = false;
            that.$message({
              message: "申请成功",
              type: "success"
            });
            that.form.da.id = that.zhenshiId;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    fuZhen (id, firstTime, unmber) {
      // for (let i = 0; i < this.form.da.otherNumbers.length; i++) {
      //     if(this.form.da.otherNumbers[i]>this.form.da.otherNumbers[i+1]){
      //         number = this.form.da.otherNumbers[i];
      //     }else{
      //         number = this.form.da.otherNumbers[i+1];
      //     }
      // }
      this.$router.push({
        path: "/diagnosis",
        query: { id: id, firstTime: firstTime, unmber: unmber }
      });
    },
    //直接购买药品
    addCar (id, type,acceptDoctor) {
      let that = this;
      if (!that.isLoginF()) return false;
      if (that.maxDoseList != null && that.maxDoseList.length != 0) {
        let messageName = "";
        for (var i = 0; i < that.maxDoseList.length; i++) {
          if (that.maxDoseList.length == 1) {
            messageName += that.maxDoseList[i].ypglName;
          } else {
            messageName += that.maxDoseList[i].ypglName + "、";
          }
        }
        this.$alert(
          '<strong><span style="color:red">' +
          messageName +
          "</span> </strong>超出最大剂量!",
          "提示",
          {
            dangerouslyUseHTMLString: true
          }
        );
        return false;
      }
      //立即购买
      this.$router.push({
        path: "/ReceivingAddress2",
        query: {
           id: id,
           type: type,
           yaId:this.form.da.medId,
           gfId:this.$route.query.gfId,
           archivesId:that.$route.query.id,
           acceptDoctor:acceptDoctor//直接购买传0问询医师传2
          }
      });
    },

    //显示评价框
    onChangeEvaluate () {
      this.evaluateFromVisible = true;

      this.$nextTick(() => {
        document
          .getElementById("evaluateDom")
          .scrollIntoView({ behavior: "smooth" });
      });
    },
    //获取评价状态列表
    async getLevelList () {
      let that = this;
      let params = {
        sysDictType: "eva_grade"
      };
      let url = "common/findSysDictList";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.levelList = res.data;
            that.levelValue = res.data[0].value;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //评论
    saveEvaluate () {
      let that = this;
      let id = that.$route.query.id;

      if (!that.evaluateText) {
        that.$message("请输入评价内容");
        return;
      }
      let params = {
        archivesId: id,
        evaluateGrade: that.levelValue,
        content: that.evaluateText
      };

      let url = "medicalCasesPc/saveEvaluate";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.$message.success(res.msg);
            that.getDetailDangAn(id);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
      //this.that.getDetailDangAn(that.$route.query.id)
    },
    // 药品名详情事件
    drugClick (data) {
      if (data.approvalStatus == 1) {
        const routeData = this.$router.resolve({ path: '/HerbalMedicineDetail', query: { id: data.medicine } })
        window.open(routeData.href, '_blank')
      }
    },
    drugClicks (data) {
      console.log(data)
      if (data.approvalStatus == 1) {
        const routeData = this.$router.resolve({ path: '/HerbalMedicineDetail', query: { id: data.medicine } })
        window.open(routeData.href, '_blank')
      }
    }
  },

  created () {
    let that = this;
    that.getLevelList();
    that.unitMeasu()
    // that.alldrug()
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    }
    if (sessionStorage.getItem("YS")) {
      that.isYS = JSON.parse(sessionStorage.getItem("YS"));
    }

    if (!!that.$route.query.id) {
      // 档案详情
      that.id = that.$route.query.id;
      that.getDetailDangAn(that.$route.query.id).then(res => {
        if (!!that.$route.query.ysId) {
          //医师详情
          that.getYiShi(that.$route.query.ysId);
          // that.getFenXi(that.$route.query.ysId);
        }
      });
      //医案详情
      that.getDetailYiAn(that.$route.query.medId);
    }
    // 患者通知从消息页面过来的
    if (localStorage.getItem("archivesId")) {
      that.getDetailDangAn(localStorage.getItem("archivesId"));
      that.id = localStorage.getItem("archivesId");
      that.getDetailYiAn(localStorage.getItem("medId"));
      localStorage.clear();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.goutongTable tr td {
  min-width: 50px;
}
.head-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.table {
  border-collapse: collapse;
}

.three-white {
  padding: 20px 20px 26px 20px;
}
.desc-words {
  font-weight: bold;
  letter-spacing: 1.6px;
  color: #333333;
}
.date-time {
  color: #999999;
}
.common-row {
  padding-top: 20px;
  padding-bottom: 19px;
  border-bottom: 1px solid #dddddd;
}
.common-row1 {
  margin-left: 70px;
}
.more {
  text-align: center;
  margin-top: 20px;
}
.table .el-select {
  width: 100%;
}
.contentQX {
  font-size: 16px;
  line-height: 36px;
  letter-spacing: 2px;
  color: #666666;
}
.smallRedSize {
  font-size: 12px;
  color: red;
  margin-bottom: 20px;
}
.orangeQX {
  color: #f68f20;
}
.small-select-mini {
  width: 100px;
  margin-right: 10px;
}
.small-select-mini .el-input--mini .el-input__inner {
  height: 24px;
  line-height: 24px;
}
.social-share .icon-wechat .wechat-qrcode {
  top: 40px !important;
  left: -165px !important;
}
.test {
  font-size: 14px;
  color: #e35131;
  margin-bottom: 12px;
}
.test span {
  width: 18px;
  height: 18px;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #e35131;
  background-color: #e35131;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.test1 {
  font-size: 14px;
  color: #5ab1e9;
  margin-bottom: 12px;
}
.test1 span {
  width: 18px;
  height: 18px;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #5ab1e9;
  background-color: #5ab1e9;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.test2 {
  font-size: 14px;
  color: #5ecfc5;
  margin-bottom: 12px;
}
.test2 span {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #5ecfc5;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.test3 {
  font-size: 14px;
  color: #efab46;
  margin-bottom: 12px;
}
.test3 span {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #efab46;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.wuxing {
  width: 100%;
  overflow: hidden;
  margin-bottom: 2px;
  display: flex; /* 20210722 */
}
.wuxing_name {
  width: 20%;
  height: 43px;
  line-height: 43px;
  text-align: center;
  border: 1px solid #ebe7dd;
  background-color: #fffaf6;
  /*float: left;   20210722*/
}
.wuxing_num {
  width: 74.5%;
  height: 43px;
  line-height: 43px;
  text-align: left;
  padding-left: 5%;
  border: 1px solid #ebe7dd;
  background-color: #fffaf6;
  /*float: left;   20210722*/
}
.wuxi {
  margin-bottom: 22px;
}
.set-small-width {
  width: 100%;
}
.el-input__inner {
  text-align: left !important;
}

.setWidth {
  width: 80%;
}
.remarks {
  margin: -20px 0 10px 0;
  margin-left: 8px;
  color: #f64320;
}

.soan {
  cursor: pointer;
  text-decoration: underline;
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/JW/archives.vue